import * as React from "react";
import {TrackerPolicy} from "@models/tracker-policy";
import Table from "@components/tracker-policies/Table";
import {Button, Card} from "antd";
import {FormattedMessage} from "react-intl";
import SearchComponent from "@components/tracker-policies/Search";
import {NavLink} from "react-router-dom";
import whitListData from "@hocs/withListData";
import trackerPolicy from "@api/tracker-policy";
import withPaginationComponent from "@hocs/withPaginationComponent";



interface PropsFromHoc {
  data          :TrackerPolicy[];
  isFetched     : boolean;
  currentPage   : number;
  search        : (params: object | null) => void;
  onDeleteItem  : (id:string) => void;
}


type AllProps = PropsFromHoc ;

const TrackerPolicysIndexPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;
  
  const deleteTrackerPolicy = (item: TrackerPolicy): any => {
    const {onDeleteItem} = props;
    trackerPolicy.delete({
        params: {id: item.id}
      })
      .then(() => {
        onDeleteItem(item.id)
      })
      .catch(error => console.log(error))
  };
  
  return (
    <div>
      <div className={`toggle-button-wrapper`}>
        <NavLink to={`/tracker-policies/create`}>
          <Button type={"primary"}>
            <FormattedMessage
              id="app.new_tracker_policy"
              defaultMessage={`Create Tracker Policy`}
            />
          </Button>
        </NavLink>
      </div>
      <div className={"page-table-wrapper"}>
        <Card className={`page-table-header`} bordered={false}>
          <SearchComponent search={search}/>
        </Card>
        
        <Table
          data={data}
          currentPage={currentPage}
          rowKey={record => record.id}
          deleteFn={deleteTrackerPolicy}
          loading={!isFetched}
        />
      </div>
    </div>
  );
};


export default whitListData(
  withPaginationComponent(TrackerPolicysIndexPage),
  {
    fetchRequest: trackerPolicy.getList,
    paginationOnScroll: false
  }
);
